import _ from "lodash";
import { useMemo } from "react";

import { API_ENDPOINTS } from "../../api/constants";
import useFetches from "../../api/useFetches";

const INVESTOR_PAGE_SIZE = 10;

/**
 * Fetches any number of entity profiles and simulates paging, based on a list of
 * Funding Round objects. The investors will be pulled from Kusanagi, so only use this hook with
 * funding rounds also obtained from kusanagi, so the entity primary keys match up.
 *
 * @param fundingRounds
 * @return {Array}
 */
const useEntityProfileFetches = fundingRounds => {
  const investors = useMemo(
    () =>
      _.uniq(
        _.flatten(fundingRounds.map(fundingRound => fundingRound.investors || [])).map(
          investor => investor[1]
        )
      ),
    [fundingRounds]
  );

  const entityProfileQueries = [];
  for (let i = 0; i < investors.length; i += INVESTOR_PAGE_SIZE) {
    entityProfileQueries.push({
      url: API_ENDPOINTS.ENTITY_PROFILES(),
      queryParams: { zb_id: investors.slice(i, i + INVESTOR_PAGE_SIZE) },
      options: { enabled: fundingRounds.length > 0 },
    });
  }

  return useFetches(entityProfileQueries, {
    flattenResults: true,
  });
};

export default useEntityProfileFetches;
